@use '@/styles/tokens' as *;

.layout {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-2) var(--space-2);
  text-align: center;
}

.pattern {
  top: -24px;
  left: 0;
  width: 100%;
  height: 60%;
  z-index: 0;
}

.icon {
  width: 76px;
  height: 76px;
  object-fit: contain;
  z-index: 1;
}

.title {
  margin: 0;
  font-family: #{$font-family-heading};
  font-size: $font-size-2xl;
  font-weight: var(--font-weight-regular);
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.subtitle {
  max-width: 320px;
  margin: 0;
  font-size: $font-size-md;
  color: var(--text-muted);
}

.actions {
  display: flex;
  justify-content: center;
  gap: var(--space-3);
  margin-top: var(--space-3);
}
